import QuickLink from "./QuickLink";
import { useTranslation } from 'react-i18next';
import { useMantineColorScheme } from "@mantine/core";
import { useLocation } from "react-router-dom";
import './QuickLinks.css'
import { useAtom } from "jotai";
import { activeTabAtom } from "../../utils/atoms/activeTabAtom";

const QuickLinks = ({ handleStartTour, handleDemoProject }) => {
  const { t } = useTranslation();
  const { colorScheme } = useMantineColorScheme();
  const [activeState] = useAtom(activeTabAtom);
  const { pathname } = useLocation();
  const isDashboardRoute = pathname?.toLowerCase().includes("dashboard");

  if (activeState === "RESULT") return null;

  return (
    <div
      className={`mt-3  ${colorScheme === "dark" ? "dark-mode" : "light-mode"}`}
    >
      <div className="text-center header-title">{t('help.quickLinks')}</div>
      <div className="d-flex align-items-center justify-content-center">
        <QuickLink icon="book" text={t('help.guide')} onClick={handleStartTour} />
       {isDashboardRoute && <QuickLink icon="new_project" text={t('help.demo')} onClick={handleDemoProject} />}
      </div>
    </div>
  );
};

export default QuickLinks;